import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import Header from '../components/Header';
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import CardGrid from '../components/CardGrid';
import { AppContext } from '../context/AppContext';
import isPage from '../hoc/isPage';
import { isEmpty } from '../helpers';

class BookingsListingPage extends Component {
    static propTypes = {

        role: PropTypes.shape({
            roleID: PropTypes.string,
            role: PropTypes.string  // name of role
        }),

    }

    state = {
        reports: [],
        selectedReportOrg: '', //only used for booking reports, replaces dealership dropdown in report itself
        childDealerships: [] //only used for booking reports
    }

    handleChangeDealer = (e) => {

        const selectedReportOrg = e.target.value;

        // save this to session storage
        this.props.saveToSessionStorage('selectedReportOrg', selectedReportOrg);
        this.setState({ selectedReportOrg: selectedReportOrg })
        this.context.setState({ selectedReportOrg: selectedReportOrg })
    }

    componentDidMount() {
        let apiUrl;
        //console.log(this.context.state)

        let selectedReportOrg = this.props.getFromSessionStorage("selectedReportOrg")
        const { childDealerships } = this.context.state;
        // if no currently selected org, and we have a list of child dealerships, then just select the first dealership in the list
        if (isEmpty(selectedReportOrg) && !isEmpty(childDealerships)) {
            selectedReportOrg = childDealerships[0];
            this.props.saveToSessionStorage("selectedReportOrg", selectedReportOrg)
        }
        else if (isEmpty(selectedReportOrg) && isEmpty(childDealerships)) {
            selectedReportOrg = { orgID: this.context.state.orgID, orgName: this.context.state.orgName }
            this.props.saveToSessionStorage("selectedReportOrg", selectedReportOrg)
        }
        this.setState({ selectedReportOrg: selectedReportOrg, childDealerships: childDealerships })

        this.context.setState({ selectedReportOrg: selectedReportOrg })
        apiUrl = '/api/portal/report/GetReportTypes?reportMode=booking';

        this.props.getData(apiUrl).then(response => {
            //console.log(apiUrl)
            response.data.forEach(report => {
                //console.log(response.data)
                let path;
                let linkParams;

                path = 'booking-returns';
                linkParams = "";

                // set properties appropriately so they can be fed into the Card Grid component
                report.id = report.reportID;
                report.label = report.reportName;
                report.link = `/${path}/${report.id}`;
                report.linkParams = `?reportTitle=${report.label}${linkParams}`;
            });

            this.setState({
                reports: response.data
            });

        }).catch(error => {
            this.props.errorAlert("m0378");
        });

    }

    render() {
        let title;
        title = this.props.returnLocalizedString("m0596")

        const tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label={title} ></Tab>
        </Tabs>);

        let dealerPicker = <React.Fragment />

        dealerPicker = (
            <form className="bottom-margin-20" style={{ backgroundColor: 'white', width: '100%', padding: '20px' }}>
                <div className="search-controls">

                    <label htmlFor="dealer" className="padding-right-10">{this.props.returnLocalizedString("m0433")}</label>
                    <DropDownList id="selectedDealer"
                        name="selectedDealer"
                        value={this.state.selectedReportOrg}
                        data={this.state.childDealerships}
                        textField="orgName"
                        dataItemKey="orgID"

                        onChange={this.handleChangeDealer}
                    />
                </div></form>);

        return (
            <div>
                <Header title={title} tabs={tabs} >
                </Header>
                <section className="page-content grid-row pad-it">
                    {this.context.state.orgType === "dealergroup" && dealerPicker}
                    <div className="grid-col m-col-12 no-left-pad">
                        <CardGrid type="reports" data={this.state.reports} />
                    </div>
                </section>
            </div>
        );
    }

}

BookingsListingPage.contextType = AppContext;
export default isPage(BookingsListingPage);


// WEBPACK FOOTER //
// ./src/containers/BookingReturnsListingPage.js